import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushSizeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 9
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 5,
			opacity: .4
		}),
		/* @__PURE__ */ _jsx("path", { d: "m12 12 6.5-6.5" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgBrushSizeIcon;
